module.exports = __webpack_public_path__ + "static/img/bg_soul.58116a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global/bg_soul.png
// module id = rMub
// module chunks = 55